import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=c63f523c&scoped=true"
import script from "./Suspended.vue?vue&type=script&lang=js"
export * from "./Suspended.vue?vue&type=script&lang=js"
import style0 from "./Suspended.vue?vue&type=style&index=0&id=c63f523c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f523c",
  null
  
)

export default component.exports